import { gatewaySectorWorkFlows } from "../../../../../../../../../gateways/gatewaySectorWorkFlows";

export const getTypeOfPlaces = async ({ categoryType }) => {
  const res = await gatewaySectorWorkFlows.get(`/type-of-places?category=${categoryType}`);
  return res.data?.data || res.data;
};
